var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSparrowDeleteButton = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  className: "sparrow-delete-button",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("rect", {
  className: "sparrow-delete-button-back",
  fill: "none",
  x: 0,
  y: 0,
  width: 24,
  height: 24
}), /*#__PURE__*/React.createElement("circle", {
  className: "sparrow-delete-button-highlight",
  cx: 12,
  cy: 12,
  r: 12
}), /*#__PURE__*/React.createElement("circle", {
  className: "sparrow-delete-button-front",
  cx: 12,
  cy: 12,
  r: 8
}), /*#__PURE__*/React.createElement("path", {
  className: "sparrow-delete-icon",
  fill: "#FFF",
  d: "m13.255 12 2.236-2.236a.223.223 0 0 0 0-.313l-.942-.942a.223.223 0 0 0-.313 0L12 10.745 9.765 8.509a.223.223 0 0 0-.314 0l-.942.942a.221.221 0 0 0 0 .313L10.745 12l-2.236 2.236a.221.221 0 0 0 0 .313l.942.942a.223.223 0 0 0 .314 0L12 13.255l2.236 2.236a.223.223 0 0 0 .313 0l.942-.942a.223.223 0 0 0 0-.313L13.255 12Z"
}))));
export default SvgSparrowDeleteButton;